import { render, staticRenderFns } from "./BankConnection.vue?vue&type=template&id=3b95210d&scoped=true&"
import script from "./BankConnection.vue?vue&type=script&lang=js&"
export * from "./BankConnection.vue?vue&type=script&lang=js&"
import style0 from "./BankConnection.vue?vue&type=style&index=0&id=3b95210d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b95210d",
  null
  
)

export default component.exports